import { FormControlLabel, styled } from '@mui/material';

import { colorPrimary } from '../../../styles/mui/colors';

type BadgeProps = {
  'data-bg-color': string;
};

export const StyledBadge = styled('span')<BadgeProps>(props => ({
  aspectRatio: 1,
  backgroundColor: props['data-bg-color'],
  borderRadius: 'var(--border-radius-large)',
  height: 'var(--preference-label-badge-size)',
  width: 'var(--preference-label-badge-size)',
}));

export const StyledLabel = styled(FormControlLabel)(
  ({ 'aria-checked': isChecked, theme }) => ({
    '& > .MuiTypography-root': {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      gap: 'var(--spacing-tiny)',
    },
    '&:focus-within': {
      backgroundColor: theme.palette.neutral.light,
    },
    '&:hover': {
      backgroundColor: theme.palette.grey[200],
    },
    borderRadius: 'var(--border-radius-tiny)',
    margin: 0,
    width: '100%',
    ...(isChecked && {
      '&:focus-within': { backgroundColor: colorPrimary[200] },
      '&:hover': { backgroundColor: colorPrimary[100] },
      backgroundColor: colorPrimary[50],
    }),
  }),
);

export const StyledName = styled('p')(() => ({
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 'var(--preference-button-line-clamp)',
  display: '-webkit-box',
  lineClamp: 'var(--preference-button-line-clamp)',
  overflow: 'hidden',
  paddingInline: 'var(--spacing-tiny)',
  textWrap: 'wrap',
  wordBreak: 'break-all',
}));
